/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class ItemListIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" css={Color}>
        <g id="그룹_5431" data-name="그룹 5431" transform="translate(5430 -50)">
          <rect id="사각형_5533" data-name="사각형 5533" width="17" height="17" transform="translate(-5430 50)" fill="red" opacity="0"/>
          <g id="그룹_5430" data-name="그룹 5430">
            <path id="패스_4398" data-name="패스 4398" d="M13.456-.022H1.388A1.438,1.438,0,0,0-.053,1.425v13.4a1.428,1.428,0,0,0,1.442,1.393H13.51a1.438,1.438,0,0,0,1.442-1.447V1.425A1.52,1.52,0,0,0,13.456-.022ZM13.51,14.4a.366.366,0,0,1-.374.375l-11.374.054a.366.366,0,0,1-.374-.375V1.854a.366.366,0,0,1,.374-.375l11.427-.054a.358.358,0,0,1,.32.375V14.4Z" transform="translate(-5428.949 50.4)"/>
            <rect id="사각형_5439" data-name="사각형 5439" width="9" height="1" rx="0.5" transform="translate(-5425.947 62.019)"/>
            <rect id="사각형_5439-2" data-name="사각형 5439" width="7" height="1" rx="0.5" transform="translate(-5424.947 60.019)"/>
            <path id="다각형_3" data-name="다각형 3" d="M2.571.365a.2.2,0,0,1,.359,0l.6,1.216a.2.2,0,0,0,.156.11l1.379.166a.2.2,0,0,1,.11.347l-1,.9a.2.2,0,0,0-.063.188l.26,1.3a.2.2,0,0,1-.289.216l-1.235-.65a.2.2,0,0,0-.186,0L1.422,4.8a.2.2,0,0,1-.289-.216l.26-1.3A.2.2,0,0,0,1.33,3.1l-1-.9a.2.2,0,0,1,.11-.347l1.379-.166a.2.2,0,0,0,.156-.11Z" transform="translate(-5424.25 53.019)"/>
          </g>
        </g>
      </svg>

    )
  }
}
